
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/context-module-progressions/jst/ProgressionStudentView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing;


  buffer += "<div class=\"student\">\n  <a id=\"progression_student_";
  if (helper = helpers.id) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.id); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"\n     href=\"#\"\n     role=\"button\"\n     aria-controls=\"progression_modules\"\n     aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'name': ((depth0 && depth0.name)),
    'scope': ("modules.progression_student_view")
  },data:data},helper ? helper.call(depth0, "show_progressions_for_student", "Show progressions for %{name}", options) : helperMissing.call(depth0, "t", "show_progressions_for_student", "Show progressions for %{name}", options)))
    + "\">\n    ";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\n  </a>\n</div>";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  